import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'pages/login',
  },
  {
    path: '*',
    redirect: 'error-404',
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: {
      title: 'Dashboard',
      requiresAuth: true,
    },
  },
  {
    path: '/pages/login',
    name: 'pages-login',
    component: () => import('@/views/pages/Login.vue'),
    meta: {
      layout: 'blank',
      title: 'Login',
      requiresVisitor: true,
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/pages/Error.vue'),
    meta: {
      layout: 'blank',
      title: '404|Not Found',
    },
  },
  {
    path: '/new-order-dine-in',
    name: 'new-order-dine-in',
    component: () => import('@/views/cashier_interface/order_transaction/NewOrder'),
    meta: {
      title: 'New Order Dine IN',
      requiresAuth: true,
      requiresOFFICER: true,
      requiresWaiter: true,
    },
  },
  {
    path: '/add-new-order-dine-in',
    name: 'add-new-order-dine-in',
    component: () => import('@/views/cashier_interface/order_transaction/AdditionalOrder'),
    meta: {
      title: 'Add New Order Dine IN',
      requiresAuth: true,
      requiresOFFICER: true,
      requiresWaiter: true,
    },
  },
  {
    path: '/fund-summary',
    name: 'fund-summary',
    component: () => import('@/views/reports_interface/FundSummary'),
    meta: {
      title: 'Callers Fund Summary',
      requiresAuth: true,
    },
  },
  {
    path: '/admin-register-users',
    name: 'admin-register-users',
    component: () => import('@/views/admin_interface_special/NewUser'),
    meta: {
      title: 'New User',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin-register-branch',
    name: 'admin-register-branch',
    component: () => import('@/views/admin_interface_special/NewBranch'),
    meta: {
      title: 'New Branch',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/deposit-liquidations',
    name: 'deposit-liquidations',
    component: () => import('@/views/cashier_interface/deposit_slip/Liquidation'),
    meta: {
      title: 'Deposit Slip',
      requiresAuth: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/deposit-slips-data',
    name: 'deposit-slips-data',
    component: () => import('@/views/view_interface/DepositSlipsData'),
    meta: {
      title: 'Deposit Slips Data',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/bank-transaction-summary',
    name: 'bank-transaction-summary',
    component: () => import('@/views/view_interface/BankTransactionSummary'),
    meta: {
      title: 'Bank Transaction Summary',
      requiresAuth: true,
      requiresAdmin: true,
      requiresManager: true,
    },
  },
  {
    path: '/admin-register-menu',
    name: 'admin-register-menu',
    component: () => import('@/views/admin_interface_special/NewMenu'),
    meta: {
      title: 'Register Menu',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/travel-order-summary',
    name: 'travel-order-summary',
    component: () => import('@/views/reports_interface/TravelOrderSummary'),
    meta: {
      title: 'Purchase Order Summary',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/list-of-customers',
    name: 'list-of-customers',
    component: () => import('@/views/reports_interface/ListOfCustomers'),
    meta: {
      title: 'List Of Customers',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/service-summary',
    name: 'service-summary',
    component: () => import('@/views/reports_interface/ServiceSummary'),
    meta: {
      title: 'Service Summary',
      requiresAuth: true,
      requiresAdmin: true, requiresOFFICER: true,
    },
  },

  {
    path: '/client-payment',
    name: 'client-payment',
    component: () => import('@/views/cashier_interface/ClientsPayment'),
    meta: {
      title: 'New Order Dine IN',
      requiresAuth: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/register-customer',
    name: 'register-customer',
    component: () => import('@/views/admin_interface_special/NewBusiness'),
    meta: {
      title: 'New Customer',
      requiresAuth: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/search-info',
    name: 'search-info',
    component: () => import('@/views/search_interface/SearchCustomers'),
    meta: {
      title: 'Search Customer',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/new-loan',
    name: 'new-loan',
    component: () => import('@/views/loan_interface/NewLoan'),
    meta: {
      title: 'New Loan',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/list-of-loan',
    name: 'list-of-loan',
    component: () => import('@/views/loan_interface/report_interface/ListOfLoan'),
    meta: {
      title: 'List Of Loan',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/list-of-pending-loan',
    name: 'list-of-pending-loan',
    component: () => import('@/views/loan_interface/report_interface/ListOfLoanPending'),
    meta: {
      title: 'List Of Pending Loan',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/monthly-deductions-loan',
    name: 'monthly-deductions-loan',
    component: () => import('@/views/loan_interface/report_interface/MontlyDeductionReport'),
    meta: {
      title: 'Monthly Deduction Report',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/monthly-summary-deductions-loan',
    name: 'monthly-summary-deductions-loan',
    component: () => import('@/views/loan_interface/report_interface/MontlySummaryDeductionReport'),
    meta: {
      title: 'Monthly Summary Deduction Report',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/monthly-due-loan',
    name: 'monthly-due-loan',
    component: () => import('@/views/loan_interface/report_interface/MontlyDueReport'),
    meta: {
      title: 'Monthly Due Report',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/monthly-collection-loan',
    name: 'monthly-collection-loan',
    component: () => import('@/views/loan_interface/report_interface/MontlyCollectionReport'),
    meta: {
      title: 'Monthly Collection Report',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/delinquent-account-loan',
    name: 'delinquent-account-loan',
    component: () => import('@/views/loan_interface/report_interface/ListOfDeliquentAccount'),
    meta: {
      title: 'List Of Delinquent Account',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/loan-payment',
    name: 'loan-payment',
    component: () => import('@/views/loan_interface/payment_interface/MainInterface'),
    meta: {
      title: 'Loan Payment',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/remittances',
    name: 'remittances',
    component: () => import('@/views/loan_interface/RemittancesReport'),
    meta: {
      title: 'Remittances Report',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
  {
    path: '/list-of-deductions-loans',
    name: 'list-of-deductions-loans',
    component: () => import('@/views/loan_interface/report_interface/ListOfDeductionReport'),
    meta: {
      title: 'List Of Deduction Report',
      requiresAuth: true,
      requiresAdmin: true,
      requiresOFFICER: true,
    },
  },
]

const router = new VueRouter({
  // mode: "history",
  routes,
})

export default router
